import createReducer from 'utils/redux/createReducer'

const initialState = {
  isLoading: false
}

export default createReducer(initialState, {
  LOADING: (currentState, action) => ({...currentState, isLoading : true})
  , NOT_LOADING: (currentState, action) => ({...currentState, isLoading : false})
})



// WEBPACK FOOTER //
// ./src/reducers/loaderReducers.js